import {RouteConfig} from 'vue-router';
import localizationFactory from "@/router/modules/localization-factory";

export default Array<RouteConfig>(
	{
		name: "PayrollMain",
		path: "/",
		component: () => import('../../views/Payroll/Payroll.vue'),
		meta: {
			layout: "main",
			className: "header-exchange-rates"
		},
	},
	{
		name: "PayrollUpload",
		path: "upload",
		component: () => import('../../views/Payroll/Payroll.vue'),
		meta: localizationFactory('payroll.downloadPayroll.title', {
			layout: "main",
			className: "header-exchange-rates"
		}),
	},
	{
		name: "NewPayroll",
		path: "new-payroll",
		component: () => import('../../views/Payroll/NewPayroll.vue'),
		meta: localizationFactory('payroll.newPayroll.header', {
			layout: "main",
			className: "d-sm-block d-none"
		}),
	}
);